<!-- uebungen-library-create-uebung-modal.vue -->
<template>
  <div class="uebungen-library__modal flex flex-col fixed top-0 left-0 w-screen h-screen z-[1000]">
    <div
      class="uebungen-library__modal-header relative flex flex-row justify-center items-center px-20 bg-primary-900 text-white transition-all delay-75">
      <button @click="closeModal"
        class="flex flex-row items-center  py-3 px-8 hover:text-secondary_color transition-all">
        <hermeneus-icon name="hi-uebungen-new" color="current" height="48" width="48" class="mr-2"></hermeneus-icon>
        <span class="text-xl  font-light md-minus:hidden">Übungsbibliothek</span>

      </button>
      <i class="fas fa-angle-right mx-5"></i>
      <button
        @click="loadComponentInModal('uebungen-library-create-uebung', 'Übung erstellen: Auswahl', 'hi-uebung-create')"
        :class="{ 'bg-primary-800': component_alias === 'uebungen-library-create-uebung', 'bg-primary-900': component_alias !== 'uebungen-library-create-uebung' }"
        class=" flex flex-row items-center bg-primary-800 py-3 px-8 hover:text-secondary_color transition-all">
        <hermeneus-icon name="hi-uebung-create" color="current" height="48" width="48" class="mr-2"></hermeneus-icon>
        <span class="text-xl  font-light md-minus:hidden">Übung erstellen: Auswahl</span>
      </button>
      <!-- DATEN DER AKTUELLEN KOMPONENTE WERDEN HIER IM HEADER ANGEZEIGT -->
      <div v-if="component_alias && (component_alias !== 'uebungen-library-create-uebung')"
        class="flex flex-row items-center">
        <i class="fas fa-angle-right mx-5"></i>
        <button
          class=" flex flex-row items-center py-3 px-8 bg-white text-primary-700 hover:text-secondary_color transition-all">
          <hermeneus-icon :name="component_icon" color="current" height="48" width="48" class="mr-2"></hermeneus-icon>
          <span class="text-xl md-minus:hidden">{{ component_title }}</span>
        </button>
      </div>
      <button class="absolute right-8 top-1/2 transform -translate-y-1/2 text-primary-400 hover:text-white" @click="closeModal"><i class="text-3xl fas fa-times"></i></button>
    </div>
    <div class="uebungen-library__modal-content flex-grow overflow-auto">
      <transition name="slide" mode="out-in">
        <component :is="component_alias ?? 'uebungen-library-create-uebung'"></component>
      </transition>
    </div>
  </div>
</template>

<script>

import UebungenLibraryCreateUebung from "./UebungenLibraryCreateUebung.vue";
import { EventBus } from "../../hermeneus.eventbus/eventbus.js";

export default {
  name: 'uebungen-library-create-uebung-modal',
  components: { UebungenLibraryCreateUebung },

  props: {},

  data() {
    return {
      component_alias: null,
      component_title: null,
      component_icon: null,

    }
  },


  methods: {
    closeModal() {
      this.$emit('close-create-uebung-modal');
    },
    loadComponentInModal(component_alias, component_title, component_icon) {
      this.component_alias = component_alias;
      this.component_title = component_title;
      this.component_icon = component_icon;
    }
  },
  mounted() {
    /**
     * Event Listener für das Laden von Komponenten in das Modal
     */
    EventBus.$on('uebungen-library__load-component-in-modal', ComponentData => {
      this.loadComponentInModal(ComponentData.component_alias, ComponentData.component_title, ComponentData.component_icon);
    });


  }
}
</script>

<style scoped>
.uebungen-library__modal {
  background-color: hsl(232deg 23% 13%); 
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.uebungen-library__modal-header {
  opacity: 0;
  animation: fadeIn 0.5s ease-in-out forwards;
  animation-delay: 500ms;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

/*.uebungen-library__modal-content {
  overflow: hidden;
}*/
</style>